import axios from 'axios';
import _ from 'lodash';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { getDefaultErrorMessage } from 'utils/axios';

import { showErrorMessageAction } from 'store/global/actions/messages.actions';

const getIsSuppressedForbiddenError = err =>
  err?.response?.status === HTTP_RESPONSE_STATUS_CODES.FORBIDDEN &&
  !!err?.response?.config?.skipResponseInterceptor?.forbiddenError;

export const catchAsyncActionError =
  actionCreator =>
  params =>
  (...storeUtils) => {
    const [dispatch] = storeUtils;

    const safeParams = _.isObject(params) && params !== null ? params : {};
    const { pendingAction, rejectedAction, silent, ...filteredParams } = safeParams;
    const shouldPassFilteredParams = !!(pendingAction || rejectedAction || silent);

    if (pendingAction) {
      dispatch(pendingAction(filteredParams));
    }

    const asyncAction = actionCreator(shouldPassFilteredParams ? filteredParams : params);

    return asyncAction(...storeUtils).catch(err => {
      const isRequestCancelled = axios.isCancel(err);
      const isSuppressedForbiddenError = getIsSuppressedForbiddenError(err);

      if (!isRequestCancelled && !silent && !isSuppressedForbiddenError) {
        const message = getDefaultErrorMessage(err);
        dispatch(
          showErrorMessageAction({
            message,
            err,
          }),
        );
      }

      if (rejectedAction) {
        dispatch(rejectedAction(filteredParams));
      }

      return Promise.reject(err);
    });
  };
